import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import accounts from './modules/accounts'
import checklists from './modules/checklistsStore'
import vendors from './modules/vendors'
import vendorAccounts from './modules/vendor-accounts'
import exportModule from './modules/export'
import download from './modules/downloadStore'
import productsStore from './modules/productsStore'
import shared from './shared'
import budgetToolStore from './modules/budgetToolStore'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    export: exportModule,
    user: user,
    accounts: accounts,
    shared: shared,
    checklists: checklists,
    vendors: vendors,
    download: download,
    vendorAccounts: vendorAccounts,
    products: productsStore,
    budgetToolStore: budgetToolStore
  }
})
